enum SnackbarType {
  SUCCESS = "green",
  ERROR = "red",
  INFO = "blue-grey",
  LOADING = "yellow",
}

export default SnackbarType;
